module.exports = __webpack_public_path__ + "img/icon-menu_teal.21c7603c.svg";